import type { ClerkAPIResponseError } from '@/features/auth/shared/types/clerk';

export const extractClerkErrorMessage = (error: unknown): string | undefined => {
  const err = error as ClerkAPIResponseError;
  return err.errors?.[0]?.message ?? err.errors?.[0]?.longMessage;
};

export const extractClerkErrorCode = (error: unknown): string | undefined => {
  const err = error as ClerkAPIResponseError;
  return err.errors?.[0]?.code;
};
